import * as Api from 'redux/api/Applications/Endpoints/v3'
import * as Types from 'redux/actions/Applications/types'

import { toggleSnackbarOpen } from '../../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

export function tryUpdateEndpoint(id, attributes) {
  return (dispatch) => {
    dispatch({
      type: Types.UPDATE_ENDPOINT
    })

    const body = {
      data: {
        attributes
      }
    }

    Api.update(id, body)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_ENDPOINT_SUCCESS,
          payload: response.data.data
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch({
          type: Types.UPDATE_ENDPOINT_FAILED
        })

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}
